module.exports = __webpack_public_path__ + "static/img/sta-car.0af79fee.png";